export default __webpack_public_path__ + "static/media/G0890_Blood_volumes.1703839800000.a4794bc3.jpg";